module.exports = __webpack_public_path__ + "static/media/expand-arrows.20458f0a.svg";